'use strict';

import { combineReducers } from 'redux';
import update from 'immutability-helper';

import * as types from './types';
import * as aTypes from '@/state/domains/assignments/types';
import * as llTypes from '@/state/domains/locationList/types';

const byId = (
    state = {},
    action
) => {

	let jobs, job;

    switch (action.type) {

		case llTypes.POST_ADD_TO_ROUTE_COMPLETED:
		case types.FETCH_JOB_COMPLETED:

			({ job } = action.data);

			if (job) {
				return { ...state, [ job._id ]: job };
			}

			return state;

		/*case types.GET_JOBS_COMPLETED:

			({ jobs } = action.data);

			return {
				...state,
				...jobs.reduce(
					(byId, j) => ({ ...byId, [ j._id ]: j }),
					{}
				),
			};*/

        case types.FETCH_ASSIGNED_COMPLETED:

			const { assigned } = action.data;

            jobs = assigned.reduce(
				(byId, j) => ({ ...byId, [ j._id ]: j }),
				{}
			);

            return { ...state, ...jobs };

		case types.POST_COMPLETE_TASK_COMPLETED:
		case types.POST_UNCOMPLETE_TASK_COMPLETED:
			
			({ job } = action.data);
			/*const oldJob = state[ job._id ];
			const { property, subunit } = oldJob;

			job.property = property;
			job.subunit = subunit;*/

			return { ...state, [ job._id ]: job };

		case aTypes.GET_ASSIGNMENTS_COMPLETED:

			({ jobs } = action.data);

			return {
				...state,
				...jobs.reduce(
					(byId, j) => ({ ...byId, [ j._id ]: j }),
					{}
				),
			};

        default:
            return state;
    }
}

const allIds = (state = [], action) => {

	let ids, job;

    switch (action.type) {

		case llTypes.POST_ADD_TO_ROUTE_COMPLETED:
		case types.FETCH_JOB_COMPLETED:

			({ job } = action.data);

			if (job) {
				return [ ...new Set([ ...state, job._id ]) ];
			}

			return state;

        case types.FETCH_ASSIGNED_COMPLETED:

            ids = action.data.assigned.map(j => j._id);

			return [ ...new Set([ ...state, ...ids ]) ];

		//case types.GET_JOBS_COMPLETED:
		case aTypes.GET_ASSIGNMENTS_COMPLETED:

            ids = action.data.jobs.map(j => j._id);

			return [ ...new Set([ ...state, ...ids ]) ];

        default:
            return state;
    }
}

const orders = combineReducers({
    byId,
    allIds
});

export default orders;
